/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import originalImg from 'assets/images/original.svg'
import by_valueImg from 'assets/images/by-value.svg'
import by_referenceImg from 'assets/images/by-reference.svg'
import fullImg from 'assets/images/full.svg'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - Присвоение по ссылке и по значению</h2>
    <p className={styles.description}>
      Фундаментальным отличием сложных типов от примитивов, является то, как они хранятся и копируются.{' '}
    </p>
    <p className={styles.description}>
      Примитивы: <code className={styles.code}>строки</code>, <code className={styles.code}>числа</code>,{' '}
      <code className={styles.code}>були</code>, <code className={styles.code}>null</code> и{' '}
      <code className={styles.code}>undefined</code>, при присваивании копируются целиком, <b>по значению (by value)</b>
      .
    </p>
    <p className={styles.description}>
      Со сложными типами всё не так. В переменной, которой присвоен массив или объект, хранится не само значение, а
      адрес его места в памяти, иными словами — ссылка (указатель) на него, и передаются они{' '}
      <b>по ссылке (by reference)</b>.{' '}
    </p>
    <p className={styles.description}>
      Представим переменную в виде листа бумаги. Значение этой переменной мы представим в виде записи на этом листе.{' '}
    </p>
    <img className={styles.img} src={originalImg} alt="original" />
    <p className={styles.description}>
      Если мы захотим сообщить содержимое этой записи пользователям то мы можем поступить так — сделать физические копии
      и вручить их каждому, то есть сделать множественные независимые копии (присвоение по значению).{' '}
    </p>
    <img className={styles.img} src={by_valueImg} alt="by-value" />
    <p className={styles.description}>
      Или поместить лист в закрытой комнате и дать пользователям ключ от этой комнаты, то есть 1 экземпляр с общим
      доступом (присвоение по ссылке).
    </p>
    <img className={styles.img} src={by_referenceImg} alt="by-reference" />
    <p className={styles.description}>
      Теперь изменим данные на листе бумаги, значение переменной. Очевидно, что посетители комнаты всегда будут видеть
      изменения которые мы вносим, так как изменяется оригинал и они имеют доступ к нему. И также очевидно, что
      владельцы бумажных копий не заметят изменений глядя на свои копии.{' '}
    </p>
    <img className={styles.img} src={fullImg} alt="full" />
    <p className={styles.description}>
      При передаче по значению, переменным выделяется новая ячейка памяти и в нее копируется данные. Аналогия с
      множественными копиями бумажного листа имеет вполне реальное воплощение, отдельный лист для каждой копии.{' '}
    </p>
    <p className={styles.description}>
      При передаче по ссылке, вместо создания нового объекта, переменной присваивается ссылка (указатель) на уже
      существующий объект, то есть на его место в памяти. Таким образом несколько переменных могут указывать на один и
      тот же объект, по аналогии с закрытой комнатой, у них есть ключ доступа к оригиналу листа.{' '}
    </p>
    <p className={styles.description}>Все примитивные типы присваиваются по значению, то есть создается копия. </p>
    <CopyBlock
      text={`let a = 5;
// Присвоение по значению, в памяти будет создана еще
// одна ячейка в которую будет скопировано значение 5
let b = a;
console.log(a); // 5
console.log(b); // 5

// Изменим значение a
a = 10;
console.log(a); // 10
// Значение b не изменилось так как это отдельная копия
console.log(b); // 5`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Сложные типы - объекты, массивы, функции присваиваются по ссылке, то есть переменная просто получает ссылку на уже
      существующий объект.
    </p>
    <CopyBlock
      text={`const a = ['Mango'];
// Присвоение по ссылке.
// Так как a это массив, в b записывается ссылка на уже существующий
// массив в памяти. Теперь a и b указывают на один и тот же массив.
const b = a;
console.log(a); // ['Mango']
console.log(b); // ['Mango']

// Изменим массив, добавив еще один элемент, используя указатель из a
a.push('Poly');
console.log(a); // ['Mango', 'Poly']

// b изменилось тоже, потому что b, как и a,
// просто содержат ссылку на одино и то же место в памяти
console.log(b); // ['Mango', 'Poly']

// Результат повторяется
b.push('Ajax');
console.log(a); // ['Mango', 'Poly', 'Ajax']
console.log(b); // ['Mango', 'Poly', 'Ajax']`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
